import { render, staticRenderFns } from "./UIExpansionPanels.vue?vue&type=template&id=6decc872"
import script from "./UIExpansionPanels.vue?vue&type=script&lang=js"
export * from "./UIExpansionPanels.vue?vue&type=script&lang=js"
import style0 from "./UIExpansionPanels.vue?vue&type=style&index=0&id=6decc872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports